export default __webpack_public_path__ + "static/media/coin-circle.a36dac28.svg";